import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
import type { HTMLAttributes } from "react";
interface LoaderIconProps {
  size?: number;
}
const LoaderIcon = t0 => {
  const $ = _c(6);
  const {
    size: t1
  } = t0;
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      color: "currentcolor"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <title>Loader</title>;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <g clipPath="url(#clip0_2393_1490)"><path d="M8 0V4" stroke="currentColor" strokeWidth="1.5" /><path d="M8 16V12" opacity="0.5" stroke="currentColor" strokeWidth="1.5" /><path d="M3.29773 1.52783L5.64887 4.7639" opacity="0.9" stroke="currentColor" strokeWidth="1.5" /><path d="M12.7023 1.52783L10.3511 4.7639" opacity="0.1" stroke="currentColor" strokeWidth="1.5" /><path d="M12.7023 14.472L10.3511 11.236" opacity="0.4" stroke="currentColor" strokeWidth="1.5" /><path d="M3.29773 14.472L5.64887 11.236" opacity="0.6" stroke="currentColor" strokeWidth="1.5" /><path d="M15.6085 5.52783L11.8043 6.7639" opacity="0.2" stroke="currentColor" strokeWidth="1.5" /><path d="M0.391602 10.472L4.19583 9.23598" opacity="0.7" stroke="currentColor" strokeWidth="1.5" /><path d="M15.6085 10.4722L11.8043 9.2361" opacity="0.3" stroke="currentColor" strokeWidth="1.5" /><path d="M0.391602 5.52783L4.19583 6.7639" opacity="0.8" stroke="currentColor" strokeWidth="1.5" /></g>;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <defs><clipPath id="clip0_2393_1490"><rect fill="white" height="16" width="16" /></clipPath></defs>;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== size) {
    t6 = <svg height={size} strokeLinejoin="round" style={t2} viewBox="0 0 16 16" width={size}>{t3}{t4}{t5}</svg>;
    $[4] = size;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  return t6;
};
export type LoaderProps = HTMLAttributes<HTMLDivElement> & {
  size?: number;
};
export const Loader = t0 => {
  const $ = _c(12);
  let className;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      className,
      size: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
  }
  const size = t1 === undefined ? 16 : t1;
  let t2;
  if ($[4] !== className) {
    t2 = cn("inline-flex animate-spin items-center justify-center", className);
    $[4] = className;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== size) {
    t3 = <LoaderIcon size={size} />;
    $[6] = size;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== props || $[9] !== t2 || $[10] !== t3) {
    t4 = <div className={t2} {...props}>{t3}</div>;
    $[8] = props;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};